package com.eladfinish.bible.contest.screens.mikud.usecases

import com.eladfinish.bible.contest.screens.mikud.MikudRepository

class PickRandomChapterUseCase(
    private val extractMikudListUseCase: ExtractMikudListUseCase,
) {

    operator fun invoke(chapterList: String): String =
        chapterList
            .split(MikudRepository.BOOK_SEPARATOR)
            .filter { it.isNotEmpty() }
            .map { it.trim() }
            .map {
                val book = it.substringBefore(MikudRepository.DASH)
                extractMikudListUseCase(chapterList = it).map { chapter ->
                    "_" + book + MikudRepository.DASH + chapter
                }
            }
            .flatten()
            .random()
            .plus(".txt")
}
